import React from "react";
import { useEffect, useState } from "react";
import { useAuthContext } from "../../../hooks/useAuthContext";

import {
  Form,
  Button,
  Col,
  Row,
  Container,
  FormControl,
} from "react-bootstrap";
import { faFloppyDisk } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import Modal from "react-modal";

import {
  utilUpdateDocument,
  saveImageToFirebaseStorage,
  utilUpdateTables,
} from "../../../util/UtilsFirebase";

// styles
import "./ConfigAdminTrucks.css";
import { City, State } from "country-state-city";

export default function ConfigAdminTrucks() {
  const { register, setRegister } = useAuthContext();
  const [registro, setRegistro] = useState([]);
  const [infoModal, setInfoModal] = useState(false);
  const [textInfo, setTextInfo] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [image, setImage] = useState(null);
  const [imageUrl, setImageUrl] = useState(null);

  const customModalStyles = {
    content: {
      width: "600px",
      height: "200px",
      margin: "auto",
      border: "none",
      textAlign: "center",
      borderRadius: "8px",
      boxShadow: "0 2px 10px rgba(0, 0, 0, 0.15)",
    },
  };
  const customModalInfoStyles = {
    content: {
      width: "600px",
      height: "150px",
      margin: "auto",
      border: "none",
      textAlign: "center",
      borderRadius: "8px",
      boxShadow: "0 2px 10px rgba(0, 0, 0, 0.15)",
    },
  };
  const handleInfo = async (e) => {
    setTextInfo(e.target.title);
    setInfoModal(true);
  };

  useEffect(() => {
    setRegistro(register);
    setImageUrl(register.img);
  }, [register]);

  const handleChange = (e) => {
    if (e.target.type === "checkbox") {
      setRegistro({
        ...registro,
        [e.target.name]: e.target.checked,
      });
    } else if (e.target.name === "estado") {
      setRegistro({
        ...registro,
        [e.target.name]: e.target[e.target.selectedIndex].innerText,
        estadoCode: e.target.value,
      });
    } else {
      setRegistro({
        ...registro,
        [e.target.name]: e.target.value,
      });
    }
    console.log(registro);
  };

  const handleImageChange = (e) => {
    if (e.target.files[0]) {
      const selectedImage = e.target.files[0];
      const reader = new FileReader();
      reader.onloadend = () => {
        setImage(selectedImage);
        setImageUrl(reader.result);
      };
      reader.readAsDataURL(selectedImage);
    }
  };

  const handleCancelModal = () => {
    console.log("Envío del formulario cancelado");
    setIsModalOpen(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsModalOpen(true);
  };

  const handleConfirmModal = async () => {
    if (image) {
      let path = "truck-admin/" + registro.id;
      const downloadURL = await saveImageToFirebaseStorage(path, image);
      if (downloadURL) {
        setImageUrl(downloadURL);
      }
      registro.img = downloadURL;
    }
    await utilUpdateDocument("registro", registro.id, registro);
    setIsModalOpen(false);
    setRegister(registro);
    utilUpdateTables(registro.table, registro.id);
  };

  return (
    <div className="row">
      <h2 className="page-title">CONFIGURACION</h2>
      <div style={{ backgroundColor: "grey", borderRadius: 20 }}>
        <div className="project-list">
          <Form>
            <Container>
              <Row>
                <Col md={12}>
                  <Form.Group controlId="razonSocial">
                    <Form.Label>
                      Nombre comercial:{" "}
                      <i
                        title="Nombre del negocio (Se usara para mostrar el negocio en la aplicacion)"
                        className="bx bxs-info-circle icon bx-xs"
                        onClick={handleInfo}
                      ></i>
                    </Form.Label>
                    <Form.Control
                      onChange={handleChange}
                      value={registro.name}
                      name="name"
                      required
                      type="text"
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <Form.Group controlId="razonSocial">
                    <Form.Label>
                      Alias:{" "}
                      <i
                        title="Alias del negocio"
                        className="bx bxs-info-circle icon bx-xs"
                        onClick={handleInfo}
                      ></i>
                    </Form.Label>
                    <Form.Control
                      onChange={handleChange}
                      value={registro.alias}
                      name="alias"
                      required
                      type="text"
                    />
                  </Form.Group>
                </Col>
                <Col md={5}>
                  <Form.Group controlId="razonSocial">
                    <Form.Label>
                      RFC:{" "}
                      <i
                        title="RFC (Registro federal del contribuyente) del negocio"
                        className="bx bxs-info-circle icon bx-xs"
                        onClick={handleInfo}
                      ></i>
                    </Form.Label>
                    <Form.Control
                      onChange={handleChange}
                      value={registro.rfc}
                      name="rfc"
                      required
                      type="text"
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group controlId="Telefono">
                    <Form.Label>
                      Telefono:{" "}
                      <i
                        title="Telefono del negocio"
                        className="bx bxs-info-circle icon bx-xs"
                        onClick={handleInfo}
                      ></i>
                    </Form.Label>
                    <FormControl
                      value={registro.phone}
                      type="number"
                      onChange={handleChange}
                      name="phone"
                    />
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group controlId="razonSocial">
                    <Form.Label>
                      Mesas:{" "}
                      <i
                        title="Numero de mesas que maneja el negocio"
                        className="bx bxs-info-circle icon bx-xs"
                        onClick={handleInfo}
                      ></i>
                    </Form.Label>
                    <FormControl
                      value={registro.table}
                      type="number"
                      min={0}
                      onChange={handleChange}
                      name="table"
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col md={4}>
                  <Form.Group controlId="razonSocial">
                    <Form.Label>
                      País:{" "}
                      <i
                        title="País donde se ubica el negocio"
                        className="bx bxs-info-circle icon bx-xs"
                        onClick={handleInfo}
                      ></i>
                    </Form.Label>
                    <Form.Control
                      onChange={handleChange}
                      value={registro.pais}
                      readOnly
                      name="pais"
                      required
                      type="text"
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group controlId="razonSocial">
                    <Form.Label>
                      Estado:{" "}
                      <i
                        title="Estado donde se ubica el negocio"
                        className="bx bxs-info-circle icon bx-xs"
                        onClick={handleInfo}
                      ></i>
                    </Form.Label>
                    <Form.Select
                      value={registro.estadoCode}
                      onChange={handleChange}
                      name="estado"
                    >
                      {State.getStatesOfCountry("MX").map((item, index) => (
                        <option key={index} value={item.isoCode}>
                          {item.name}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group controlId="razonSocial">
                    <Form.Label>
                      Municipio:{" "}
                      <i
                        title="Municipio donde se ubica el negocio"
                        className="bx bxs-info-circle icon bx-xs"
                        onClick={handleInfo}
                      ></i>
                    </Form.Label>
                    <Form.Select
                      value={registro.ciudad}
                      onChange={handleChange}
                      name="ciudad"
                    >
                      {City.getCitiesOfState("MX", registro.estadoCode).map(
                        (item, index) => (
                          <option key={index} value={item.name}>
                            {item.name}
                          </option>
                        )
                      )}
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
            </Container>
          </Form>
          <Form>
            <div className="">
              <Row>
                <Col md={12}>
                  <Form.Group controlId="razonSocial">
                    <Form.Label>
                      Razon Social:{" "}
                      <i
                        title="Razon social del negocio"
                        className="bx bxs-info-circle icon bx-xs"
                        onClick={handleInfo}
                      ></i>
                    </Form.Label>
                    <Form.Control
                      onChange={handleChange}
                      value={registro.razon_social}
                      name="razon_social"
                      required
                      type="text"
                    />
                  </Form.Group>
                </Col>
                <Col md={12}>
                  <Form.Group controlId="Direccion">
                    <Form.Label>
                      Direccion:{" "}
                      <i
                        title="Direccion del negocio"
                        className="bx bxs-info-circle icon bx-xs"
                        onClick={handleInfo}
                      ></i>
                    </Form.Label>
                    <FormControl
                      value={registro.direccion}
                      type="text"
                      onChange={handleChange}
                      name="direccion"
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row hidden>
                <Col md={6}>
                  <Form.Group controlId="numMesas">
                    <Form.Label>Ubicacion:</Form.Label>
                    <select
                      value={registro.location}
                      disabled
                      onChange={handleChange}
                      name="location"
                    >
                      <option value={"Nogales Sur"}>Nogales Sur</option>
                      <option value={"Nogales Norte"}>Nogales Norte</option>
                    </select>
                  </Form.Group>
                </Col>
              </Row>
            </div>
            <Form.Group controlId="modoOP">
              <div className="center">
                <label>
                  Logo:{" "}
                  <i
                    title="Logo del negocio (Se usara para mostrar el negocio dentro de la aplicación)"
                    className="bx bxs-info-circle icon bx-xs"
                    onClick={handleInfo}
                  ></i>
                  <img
                    id="logo_img"
                    alt="Error al cargar imagen"
                    src={imageUrl}
                    height="150"
                    width="275"
                  />
                  <input
                    id="logoNeg"
                    type="file"
                    style={{ display: "none" }}
                    accept="image/png, image/jpeg"
                    multiple={false}
                    onChange={handleImageChange}
                  />
                </label>
              </div>
            </Form.Group>
          </Form>
        </div>
      </div>
      <Modal
        style={customModalStyles}
        isOpen={isModalOpen}
        onRequestClose={() => setIsModalOpen(false)}
        contentLabel="Confirmación"
      >
        <p>¿Desea actualizar la informacion?</p>
        <button style={{ marginRight: 5 }} onClick={handleConfirmModal}>
          Aceptar
        </button>
        <button onClick={handleCancelModal}>Cancelar</button>
      </Modal>
      <Modal
        style={customModalInfoStyles}
        isOpen={infoModal}
        onRequestClose={() => setInfoModal(false)}
      >
        <p>{textInfo}</p>
        <button style={{ marginRight: 5 }} onClick={() => setInfoModal(false)}>
          Aceptar
        </button>
      </Modal>
      <div className="center-form" style={{ marginTop: 20 }}>
        <Button variant="primary" className="button" onClick={handleSubmit}>
          <FontAwesomeIcon icon={faFloppyDisk} /> ACTUALIZAR
        </Button>
      </div>
    </div>
  );
}
